import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import Brand from "../../../model/brand/Brand";
import SearchDropdownFilter from "./SearchDropdownFilter";

class BrandFilter extends SearchDropdownFilter<Brand> {

	itemToId(item: Brand): string {
		return item.id;
	}

	itemToLabel(item: Brand): string {
		return item.name;
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.brand.brands
	}
}

export default connect(mapStateToProps)(BrandFilter)